import type { MapPadding, MapViewport } from 'lib/maps/types'
import config from './config'

/*
  Tuning for the hotel search results map (/search/map). Camera, pin retention and clustering
  behaviour read from here so the component holds no magic numbers.
*/

// Roughly the geographic centre of Australia (a bit north-east of Alice Springs). Used only as the
// initial viewport before the camera fits to the search result bounds.
export const SEARCH_MAP_INITIAL_VIEWPORT: MapViewport = {
  latitude: -25,
  longitude: 133,
  zoom: 4,
}

/** Fixed zoom for an address search, which opens centred on the address rather than fitting pins. */
export const SEARCH_MAP_LOCATION_SEARCH_ZOOM = 14

/** Padding around the pins when the camera fits to them. */
export const SEARCH_MAP_MARKER_FIT_PADDING_PX = 60

/** Window after a programmatic camera move in which move events do not count as user interaction. */
export const SEARCH_MAP_PROGRAMMATIC_MOVE_GRACE_PERIOD_MS = 300

/** How long to wait for pins before the camera refits anyway. */
export const SEARCH_MAP_MARKER_DISPLAY_TIMEOUT_MS = 2000

/** Vertical gap between a pin and the offer popup above it (desktop and tablet). */
export const SEARCH_MAP_OFFER_POPUP_OFFSET_PX = 24

/** Offers requested per search of the visible map area. */
export const SEARCH_MAP_OFFER_LIMIT = 20

/**
 * Most pins kept on the map at once, including pins retained from the previous search.
 */
export function getSearchMapDisplayedPinCap(): number {
  return config.search.mapView.pinLimit + config.search.mapView.additionalPins
}

/** Offers closer than this are the same building and share one pin. */
export const SEARCH_MAP_SAME_LOCATION_METRES = 10

// Clustering on the search map (mobile only).

/** Merge distance in px at the integer zoom. 60 chained Sydney CBD into one bubble; 50 leaves a few groups. */
export const SEARCH_MAP_CLUSTER_RADIUS_PX = 50

/**
 * Where the separated pins may land after a bubble tap. Fitting a group puts its outermost pins
 * exactly this far from the edges. The top clears the floating Filter button and the loading
 * banner, the bottom the zoom control, and the sides keep a 64px price pill well inside the edge.
 */
export const SEARCH_MAP_CLUSTER_EXPANSION_PADDING: MapPadding = {
  top: 104,
  bottom: 80,
  left: 88,
  right: 88,
}

/**
 * Street level is far enough. Every cluster has split by here: the clustering hook stops
 * clustering one level above its max zoom of 16.
 */
export const SEARCH_MAP_CLUSTER_MAX_EXPANSION_ZOOM = 17
